import { AfpantIntentionMessageResponse } from "@/components/AfpantIntentionMessageResponse/AfpantIntentionMessageResponse";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/",
)({
  loader: async ({ params }) => {
    const { orgNumber, intentionMessageResponseId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["intention-message-response"][
      ":intentionMessageResponseId"
    ].$get({
      param: {
        orgNumber,
        intentionMessageResponseId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch intention message response");
    }

    return {
      response: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Intensjonssvar | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { orgNumber } = Route.useParams();
  const { response } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Intensjonssvar</DocumentTitle>

      <AfpantIntentionMessageResponse orgNumber={orgNumber} response={response} />
    </>
  );
}
